// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prop .help code\n{\n\tbackground-color: #e9e9e9;\n\tpadding: 0px 3px;\n\tborder: 1px solid #d5d5d5;\n\tmargin: 1px;\n\tfont-family: Consolas, monospace;\n}\n.showHelp .help\n{\n\tdisplay: block !important;\n}\n", ""]);
// Exports
module.exports = exports;
